// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Image-module__image{opacity:0;-webkit-transition:opacity .2s;-o-transition:opacity .2s;transition:opacity .2s}.Image-module__image.Image-module__loaded{opacity:1}", "",{"version":3,"sources":["webpack://src/components/ProductSeries/Image.module.scss"],"names":[],"mappings":"AAAA,qBACE,SAAA,CACA,8BAAA,CAAA,yBAAA,CAAA,sBAAA,CAEA,0CACE,SAAA","sourcesContent":[".image {\n  opacity: 0;\n  transition: opacity 0.2s;\n\n  &.loaded {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": "Image-module__image",
	"loaded": "Image-module__loaded"
};
export default ___CSS_LOADER_EXPORT___;
